import { render, staticRenderFns } from "./ConsumersContactedSalons.vue?vue&type=template&id=04460f52&scoped=true"
import script from "./ConsumersContactedSalons.vue?vue&type=script&lang=js"
export * from "./ConsumersContactedSalons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04460f52",
  null
  
)

export default component.exports